import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { SvgIcon, SvgFill } from '@chegg-ui/svg-icon';
var BusuuColor = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement(SvgFill, {
    svgColor: "#fff",
    d: "M0 0h44v44H0z"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M23.206 24.569a12.54 12.54 0 0 0 9.644-4.449 12.074 12.074 0 0 0 2.87-7.807C35.734 5.54 30.138.03 23.235.03L13.29 0C7.635-.014 3.029 4.492 3.029 10.046L3 34.456c0 .03.775-9.887 20.206-9.887Z",
    svgColor: "#116EEE"
  }), /*#__PURE__*/React.createElement(SvgFill, {
    d: "M3 35.863C3 40.355 6.703 44 11.28 44h18.456c7.462.014 11.897-5.41 11.911-12.112 0-5.697-3.215-10.476-8.783-11.768a12.54 12.54 0 0 1-9.643 4.449C3.774 24.569 3 34.485 3 34.457v1.406Z",
    svgColor: "#88B7F7"
  }));
});
BusuuColor.displayName = 'BusuuColor';
BusuuColor.defaultProps = {
  'aria-label': 'BusuuColor'
};
export default BusuuColor;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg-ui/horizon-icons/dist/esm/icons/Logo/BusuuColor.js
// module id = 2944
// module chunks = 11